import { useEffect } from "react";
import { publicSupabase } from "@/integrations/supabase/publicClient";

// Hardcoded in index.html for instant load and crawler visibility
const HARDCODED_GTM_ID = "GTM-N38SK98C";

export function GoogleTagManager() {
  useEffect(() => {
    // Defer DB lookup so it doesn't block initial render
    const timer = setTimeout(async () => {
      try {
        const { data } = await publicSupabase
          .from("settings")
          .select("value")
          .eq("namespace", "tag_manager")
          .eq("key", "container_id")
          .maybeSingle();

        const dbId = data?.value;
        if (!dbId) return;

        // Validate format
        const gtmIdPattern = /^GTM-[A-Z0-9]{1,10}$/;
        if (!gtmIdPattern.test(dbId)) {
          console.error("Invalid GTM container ID format");
          return;
        }

        // Same as hardcoded → already loaded, do nothing
        if (dbId === HARDCODED_GTM_ID) return;

        // Different ID → load as override (avoid duplicates)
        if (document.querySelector(`script[src*="${dbId}"]`)) return;

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          "gtm.start": new Date().getTime(),
          event: "gtm.js",
        });

        const script = document.createElement("script");
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtm.js?id=${dbId}`;
        document.head.appendChild(script);

        const noscript = document.createElement("noscript");
        const iframe = document.createElement("iframe");
        iframe.src = `https://www.googletagmanager.com/ns.html?id=${dbId}`;
        iframe.height = "0";
        iframe.width = "0";
        iframe.style.display = "none";
        iframe.style.visibility = "hidden";
        noscript.appendChild(iframe);
        document.body.insertBefore(noscript, document.body.firstChild);
      } catch (error) {
        console.error("Failed to load GTM override:", error);
      }
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return null;
}

declare global {
  interface Window {
    dataLayer: any[];
  }
}
